<template>
  <div class="main">
    <div class="wrap">
      <ChangeXInput @phone="getPhone" />
      <NumberPanel @select="handleSelect" :disabled="handleDsiabled" />
      <ButtonPanel :point="point" :phone="phone" :id="productId" :faceValue="faceValue" :disabled="handleDsiabled" />
    </div>
    <TipPanel />
  </div>
</template>

<script>
import ChangeXInput from "@/components/charge/ChangeXInput";
import NumberPanel from "@/components/charge/NumberPanel";
import ButtonPanel from "@/components/charge/ButtonPanel";
import TipPanel from "@/components/charge/TipPanel";
let reg = /^(13[0-9]|14[57]|15[0-9]|16[0-9]|17[678]|18[0-9]|19[0-9])[0-9]{8}$/;
import api from "../../api";
import $ from "jquery";

export default {
  title: "话费直充",
  bodyClass: "gray-bg",
  components: {
    ChangeXInput,
    NumberPanel,
    ButtonPanel,
    TipPanel
  },
  data() {
    return {
      point: 0,
      phone: "",
      productId: "",
      faceValue: "",
    };
  },
  computed: {
    handleDsiabled() {
      if (reg.test(this.phone)) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    handleSelect(data) {
      this.point = data.pricePoint;
      this.productId = data.productId;
      this.faceValue = data.faceValue;
    },
    getPhone(tel) {
      this.phone = tel;
      if (!reg.test(tel)) {
        this.point = 0;
      } else { // 主动选择第一个
        setTimeout(() => {
          $('body').find('.item').eq(0).trigger('click')
        }, 50);
      }
    },

  }
};
</script>

<style lang="less" scoped>
.main {
  display: flex;
  justify-content: center;
  padding-top: 2.93vw;
  flex-wrap: wrap;
  .wrap {
    width: 94.66vw;
    background: #fff;
    border-radius: 5px;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/charge/MobileCharge.vue